import React from 'react';

import Typography from '../../../../library/typography/typography';
import FoundItLowerButton from '../../../../components/found-it-lower-button/found-it-lower-button';
import ParentProductMessage from '../../../../components/parent-product-message/parent-product-message';
import ProductQuantity from '../../../../components/product-quantity/product-quantity';
import ProductListCardPrice from '../product-list-card-price/product-list-card-price';

import {
  getProductFitmentPosition,
  isWindShieldWiperProduct
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-list-set-card-position.scss';

interface ProductListSetCardPositionProps {
  index?: number;
  isCanonical?: boolean;
  onQuantityChange: (quantity: number, index?: number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListSetCardPosition(props: ProductListSetCardPositionProps) {
  const {
    index,
    isCanonical,
    onQuantityChange,
    product,
    quantity,
    totalQuantity
  } = props;
  const isWindShieldWiper = isWindShieldWiperProduct(product);
  const productFitmentPosition = getProductFitmentPosition(product);

  function handleQuantityChange(_, updatedValue) {
    onQuantityChange(updatedValue, index);
  }

  return (
    <div styleName="container">
      {product.size && (
        <Typography
          className="product-set-description__label"
          styleName="label"
          tag="div"
          weight="black"
        >
          {productFitmentPosition ? productFitmentPosition : 'SIZE'}:
          <Typography tag="span">&nbsp;{product.size}&quot;</Typography>
        </Typography>
      )}

      <div styleName="price-qty-container">
        <ProductListCardPrice
          hideFoundItLower
          hideParentMessage
          product={product}
          quantity={quantity}
          totalQuantity={totalQuantity}
        />

        {!isCanonical && (
          <ProductQuantity
            defaultValue={isWindShieldWiper ? 1 : 2}
            id="quantity"
            onBlur={handleQuantityChange}
            onChange={handleQuantityChange}
            showLabel
            value={quantity}
          />
        )}
      </div>
      <FoundItLowerButton
        productItem={{
          product: product,
          quantity: quantity,
          totalQuantity: totalQuantity
        }}
      />
      <ParentProductMessage
        product={product}
        styleName="parent-product-message"
      />
    </div>
  );
}

export default ProductListSetCardPosition;
